import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export function authHeaders() {
  const token = localStorage.getItem("and_admin_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return "Something went wrong. Please try again.";
}
